var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75M15.75 9C15.75 5.27208 12.7279 2.25 9 2.25M15.75 9H2.25M9 15.75C5.27208 15.75 2.25 12.7279 2.25 9M9 15.75C10.6884 13.9016 11.6479 11.5029 11.7 9C11.6479 6.49712 10.6884 4.09839 9 2.25M9 15.75C7.31164 13.9016 6.35214 11.5029 6.3 9C6.35214 6.49712 7.31164 4.09839 9 2.25M2.25 9C2.25 5.27208 5.27208 2.25 9 2.25",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/icon-globe.39d0c22cbc4cac3720792689997ad169.svg";
export { ForwardRef as ReactComponent };